export default __webpack_public_path__ + "d5d0a440660681def5e4f2901cebbced.svg";